import React, { useEffect, useRef, useState } from 'react'
import Header from './Header'
import axios from 'axios'
import { API } from './constant'
import { DownloadTableExcel, useDownloadExcel } from 'react-export-table-to-excel'

const Reports = () => {

    const exportTableRef = useRef(null);
    const { onDownload } = useDownloadExcel({
        currentTableRef: exportTableRef.current,
        filename: 'Lexile Report',
        sheet: 'sheet1',
    });

    //============= ============find user role and give permission start ============================
    const [loggedinRole, setLoggedinRole] = useState("")
    const [loggedinLocation, setLoggedinLocation] = useState("")
    const [searchClass, setSearchClass] = useState('');
    const [searchSection, setSearchSection] = useState('');
    const [classSections, setClassSections] = useState({});

    const handleSearchClass = (event) => {
        setSearchClass(event.target.value.trim());
        setSearchSection(''); // Reset section when class changes
    };
    const handleSearchSection = (event) => {
        setSearchSection(event.target.value);
    };

    // console.log(loggedinLocation)

    useEffect(() => {
        axios.get(`${API}/login/logged-in-user`, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                console.log(res.data)
                setLoggedinRole(res.data.data.role)
                setLoggedinLocation(res.data.data.school_location)
            })
            .catch((err) => {
                // console.log(err);
                if (err.response) {
                    // Handle invalid token
                    if (err.response.status === 401) {
                        localStorage.removeItem("token");
                        // history.push('/');
                        window.location.href = "/"
                    }
                    // Handle token expiration
                    else if (err.response.status === 302) {
                        window.location.href = "/"

                    }
                }
            });
    }, [])
    //============= ============find user role and give permission end ============================



    // ----------get all school location start -----------
    const [allLocationData, setallLocationData] = useState([])
    useEffect(() => {
        axios.get(`${API}/school-location`)
            .then((res) => {
                // console.log(res)
                setallLocationData(res.data.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [])
    // ----------get all school location end-----------


    // ---------get all session data start ----------
    const [allsessiondata, setallsessiondata] = useState([])
    // console.log(allsessiondata)
    useEffect(() => {
        axios.get(`${API}/session`)
            .then((res) => {
                // console.log(res.data.data)
                setallsessiondata(res.data.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [])
    //----------- get all session data end-----------



    // get all classes start 
    useEffect(() => {
        axios.get(`${API}/upload/class-sections`, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res.data.data)
                setClassSections(res.data.data)
            })
            .catch(err => console.error(err));
    }, []);
    // get all classes end

    useEffect(() => {
        if (loggedinRole !== "Super Admin") {
            setSchoolLocation(loggedinLocation);
        }
    }, [loggedinRole, loggedinLocation]);



    const [session, setSession] = useState("2025-2026");
    const [schoolLocation, setSchoolLocation] = useState("");
    const [stats, setStats] = useState([]);
    const [loading, setLoading] = useState(false);





    // Fetch data
    const effectiveLocation = loggedinRole === "Super Admin"
        ? schoolLocation
        : loggedinLocation;

    const fetchData = async () => {
        if (!session) return;

        if (loggedinRole !== "Super Admin" && !loggedinLocation) return;

        if (loggedinRole === "Super Admin" && schoolLocation === "") return;
        try {
            setLoading(true);
            const res = await axios.get(`${API}/assessment`, {
                params: {
                    session,
                    // school_location: schoolLocation || undefined,
                    school_location: loggedinRole === "Super Admin"
                        ? (schoolLocation?.trim() || undefined)
                        : loggedinLocation?.trim(),
                    class: searchClass || undefined,
                    section: searchSection || undefined,
                },
                headers: {
                    "Content-Type": "application/json",
                    token: localStorage.getItem("token"),
                },
            });

            setStats(res.data.stats || []);
        } catch (error) {
            console.error("Error fetching stats:", error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (loggedinRole !== "Super Admin") {
            setSchoolLocation(loggedinLocation);
        }
    }, [loggedinRole, loggedinLocation]);

    useEffect(() => {
        fetchData();
    }, [session, schoolLocation, searchClass, searchSection]);




    return (
        <div>
            <div >
                {
                    loggedinRole && loggedinRole === "Admin" || loggedinRole === "Super Admin" ?
                        (


                            <div >
                                <Header />
                                <div className='mt-[80px] sm:mt-[150px] mx-[3px] sm:mx-[20px]'>


                                    {/* report start  */}
                                    <div className="reportcontainer mx-auto p-6">
                                        <div className='flex justify-between'>
                                            <div>
                                                <h1 className="text-2xl font-bold mb-6">📊 Student Lexile Assessment Reports</h1>
                                            </div>
                                            <div>
                                                {/* <DownloadTableExcel
                                                    filename="Lexile Report"
                                                    sheet="sheet1"
                                                    // currentTableRef={tableRef.current}
                                                    currentTableRef={exportTableRef.current}  // Reference to the hidden table
                                                > */}

                                                <button onClick={onDownload} className='bg-black text-white text-[12px] sm:text-[15px] px-[3px] py-[2px] sm:px-[10px] sm:py-[5px]'> Export excel </button>

                                                {/* </DownloadTableExcel> */}
                                            </div>

                                        </div>

                                        {/* Filters */}
                                        <div className="flex flex-wrap gap-4 mb-6">
                                            {/* Session Select */}

                                            <div>
                                                <div>
                                                    <label className="block mb-1 text-sm font-medium">Session</label>
                                                </div>
                                                <div className='search-bar '>
                                                    <div className='search-wrapper '>
                                                        <select
                                                            value={session}
                                                            onChange={(e) => setSession(e.target.value)}
                                                            className='search-input'
                                                        >
                                                            {
                                                                allsessiondata && allsessiondata.map((item, index) => {
                                                                    return (

                                                                        <option key={index} value={item.name}>{item.name}</option>

                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* School Location Select */}
                                            <div>
                                                <div>
                                                    <label className="block mb-1 text-sm font-medium">School Location</label>

                                                </div>
                                                <div className='search-bar '>
                                                    <div className="search-wrapper">
                                                        <select
                                                            disabled={loggedinRole !== "Super Admin"}
                                                            value={loggedinRole === "Super Admin" ? schoolLocation : loggedinLocation}
                                                            onChange={(e) => setSchoolLocation(e.target.value)}
                                                            className='search-input'
                                                        >
                                                            <option value="">Select school location</option>
                                                            {
                                                                allLocationData && allLocationData.map((item, index) => {
                                                                    return (
                                                                        <option value={item.name}>{item.name}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>


                                            {/* class select  */}
                                            <div>
                                                <div>
                                                    <label className="block mb-1 text-sm font-medium">School Location</label>
                                                </div>
                                                <div className='search-bar '>

                                                    <div className="search-wrapper">
                                                        <select
                                                            value={searchClass}
                                                            onChange={handleSearchClass}
                                                            className='search-input'
                                                        >
                                                            <option value="">Select Class</option>
                                                            {Object.keys(classSections).map((cls) => (
                                                                <option key={cls} value={cls}>{cls}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>

                                            </div>


                                            {/* section select  */}
                                            <div>
                                                <div>
                                                    <label className="block mb-1 text-sm font-medium">Section</label>
                                                </div>
                                                <div className='search-bar '>
                                                    <div className={`search-wrapper  ${!searchClass ? "-z-10" : ""}`}>
                                                        <select
                                                            value={searchSection}
                                                            onChange={handleSearchSection}
                                                            className='search-input'
                                                            disabled={!searchClass}
                                                        >
                                                            <option value="">Select Section</option>
                                                            {searchClass && classSections[searchClass].map((section) => (
                                                                <option key={section} value={section}>{section}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Table */}
                                        {loading ? (
                                            <p className="text-gray-500">Loading...</p>
                                        ) : stats.length === 0 ? (
                                            <p className="text-gray-500">No data found</p>
                                        ) : (
                                            <div className="overflow-x-auto shadow-md rounded-lg">
                                                <table ref={exportTableRef} className="w-full border-collapse text-left text-sm">
                                                    <thead className="bg-gray-100 text-gray-700">
                                                        <tr>
                                                            <th className="px-4 py-3 border">Class</th>
                                                            <th className="px-4 py-3 border">Section</th>
                                                            <th className="px-4 py-3 border text-center">Total Students</th>
                                                            <th className="px-4 py-3 border text-center">Accessed</th>
                                                            <th className="px-4 py-3 border text-center">Remaining</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {stats.map((row, idx) => (
                                                            <tr
                                                                key={idx}
                                                                className={idx % 2 === 0 ? "bg-white" : "bg-gray-50"}
                                                            >
                                                                <td className="px-4 py-2 border font-medium">{row.class}</td>
                                                                <td className="px-4 py-2 border">{row.section}</td>
                                                                <td className="px-4 py-2 border text-center">{row.total_students}</td>
                                                                <td className="px-4 py-2 border text-center text-green-600 font-semibold">
                                                                    {row.students_accessed}
                                                                </td>
                                                                <td className="px-4 py-2 border text-center text-red-600 font-semibold">
                                                                    {row.students_remaining}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </div>
                                    {/* report end */}


                                </div>
                            </div>
                        ) : null
                }
            </div>
        </div>
    )
}

export default Reports